var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box box-waro" },
        [
          _c("Header"),
          _c("img", {
            staticClass: "loading",
            attrs: { src: _vm.gameData.topBgImage, alt: "" },
          }),
          _c("div", { staticClass: "item_welfare" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _vm._m(1),
                _c("div", { staticClass: "position-war" }, [
                  _c("div", { staticClass: "icon" }, [
                    _c("div", { staticClass: "Purchased" }, [
                      _c("img", {
                        class: _vm.haveBuy ? "" : "animation",
                        attrs: {
                          src: require("../assets/warorderimg/gift.png"),
                          alt: "",
                        },
                      }),
                      _c(
                        "p",
                        {
                          class: _vm.haveBuy ? "" : "animation",
                          on: {
                            click: function ($event) {
                              return _vm.openConfirmOrderWindow()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.buyText) + "\n\t\t\t\t\t\t\t")]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "conter" }, [
                    _c("div", { staticClass: "conter-left" }, [
                      _c("div", { staticClass: "Daily" }, [
                        _vm._v("Daily Login rewards"),
                      ]),
                      _c("ul", [
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[0].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  0,
                                  _vm.statusObject[0].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[0].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[0].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[1].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  1,
                                  _vm.statusObject[1].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[1].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[1].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[2].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  2,
                                  _vm.statusObject[2].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[2].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[2].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[3].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  3,
                                  _vm.statusObject[3].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[3].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[3].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[4].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  4,
                                  _vm.statusObject[4].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[4].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[4].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[5].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  5,
                                  _vm.statusObject[5].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[5].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[5].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[6].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  6,
                                  _vm.statusObject[6].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[6].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[6].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "days" }),
                    _c("div", { staticClass: "conter-right" }, [
                      _c("div", { staticClass: "Super" }, [
                        _vm._v("Super Value Pack"),
                      ]),
                      _c("ul", [
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[10].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  10,
                                  _vm.statusObject[10].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[10].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[10].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[11].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  11,
                                  _vm.statusObject[11].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[11].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[11].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[12].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  12,
                                  _vm.statusObject[12].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[12].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[12].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[13].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  13,
                                  _vm.statusObject[13].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[13].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[13].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[14].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  14,
                                  _vm.statusObject[14].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[14].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[14].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[15].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  15,
                                  _vm.statusObject[15].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[15].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[15].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "li",
                          {
                            class: [_vm.statusObject[16].class],
                            on: {
                              click: function ($event) {
                                return _vm.receive(
                                  16,
                                  _vm.statusObject[16].status
                                )
                              },
                            },
                          },
                          [
                            _vm.statusObject[16].received
                              ? _c(
                                  "div",
                                  {
                                    class: _vm.statusObject[16].received
                                      ? "active"
                                      : "",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../assets/warorderimg/miaomi.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
      _c("TipsWindow", { ref: "tips" }),
      _vm.hasLogin
        ? _c("ConfirmOrder", {
            attrs: { goods: _vm.goods, rebate: _vm.rebate },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "describe" }, [
      _c("img", {
        attrs: { src: require("../assets/warorderimg/push.png"), alt: "" },
      }),
      _c("span", [_vm._v("|")]),
      _c("p", { staticClass: "marquee" }, [
        _c("span", [
          _vm._v(
            "Find more Top-up benefits in the Official Website. If you have any\n\t\t\t\t\t\t\tproblems, Please\n\t\t\t\t\t\t\tcontact customer service."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }